export const TRACK_IDS = {
    INVALID_IFRAME_MESSAGE_ORIGIN: 'INVALID_IFRAME_MESSAGE_ORIGIN',
    BEFORE_RENDER_FEEDBACK_SURVEY: 'BEFORE_RENDER_FEEDBACK_SURVEY',
    AFTER_RENDER_FEEDBACK_SURVEY: 'AFTER_RENDER_FEEDBACK_SURVEY'
};
